<template>
  <el-dialog
    :close-on-click-modal="false"
    :lock-scroll="true"
    :visible.sync="show"
    width="78%"
    top="30px"
    center
    :show-close="false"
    :close-on-press-escape="false"
  >
    <billTitleTemplate :title="user.companyTitle + '借款申请单'" :to-void="toVoid"></billTitleTemplate>
    <div style="margin-bottom: 10px;">
      <el-row>
        <el-col :span="2" center>&nbsp;</el-col>
        <el-col :span="6" center>申请部门：{{ jksqd.bmmc }}</el-col>
        <el-col :span="4" center>日期：<span v-text="jksqd.rq"></span></el-col>
        <el-col :span="2" center>&nbsp;</el-col>
        <el-col :span="5" center>单据号：<span v-text="jksqd.djh"></span></el-col>
        <el-col :span="3"><span style="float: right">单位：元</span></el-col>
      </el-row>
    </div>
    <table style="width: 90%;margin: 1px auto;text-align: center">
      <col style="width: 5%">
      <col style="width: 13%">
      <col style="width: 5%">
      <col style="width: 5%">
      <col style="width: 5%">
      <col style="width: 5%">
      <tr>
        <td><span style="line-height: 44px">借款人</span></td>
        <td style="text-align: left">
          <el-select v-if="view === 'edit'" v-model="jksqd.jkr" placeholder="请选择借款人" filterable @change="jkrChange">
            <el-option
              v-for="item in optionsFyBxUser"
              :key="item.subjectCode"
              :label="item.subjectName"
              :value="[item.subjectName,item.subjectCode,item.dictCode,item.dictName]">
            </el-option>
          </el-select>
          <span v-else>{{ jksqd.jkr }}</span>
        </td>
        <td><span>集团总裁</span></td><td v-text="lcPersons[9]"></td>
        <td><span>集团CFO</span></td><td v-text="lcPersons[8]"></td>
      </tr>
      <tr>
        <td><span style="line-height: 44px">款项用途</span></td>
        <td><el-input v-if="view === 'edit'" v-model="jksqd.kxyt"></el-input><span v-else>{{ jksqd.kxyt }}</span></td>
        <td><span style="line-height: 44px">总经理</span></td><td v-text="lcPersons[7]"></td>
        <td><span>董事长</span></td><td v-text="lcPersons[6]"></td>
      </tr>
      <tr>
        <td><span style="line-height: 44px">金额（小写）</span></td>
        <td><el-input v-if="view === 'edit'" v-model="jksqd.je" @change="jeChange"></el-input><span v-else>{{ jeXx }}</span></td>
        <td><span style="line-height: 44px">总会计师</span></td><td v-text="lcPersons[5]"></td>
        <td><span>副总经理</span></td><td v-text="lcPersons[4]"></td>
      </tr>
      <tr>
        <td><span style="line-height: 44px">金额（大写）</span></td>
        <td><span v-text="jeDx"></span></td>
        <td><span style="line-height: 44px">财务部长</span></td><td v-text="lcPersons[3]"></td>
        <td><span>部门负责人</span></td><td v-text="lcPersons[2]"></td>
      </tr>
      <tr>
        <td><span style="line-height: 44px">出差事由</span></td>
        <td><span v-text="jksqd.ccsy"></span></td>
        <td><span>审核会计</span></td><td v-text="lcPersons[1]"></td>
        <td><span>经办人</span></td><td v-text="jksqd.lrr"></td>
      </tr>
      <tr>
        <td><span style="line-height: 44px">出差地点</span></td>
        <td><span v-text="jksqd.ccdd"></span></td>
        <td><span style="line-height: 44px">出差依据</span></td>
        <td colspan="3"><!--<el-input v-model="ccyj" placeholder="请输入备注"></el-input>--></td>
      </tr>
    </table>
    <!-- 审核情况 -->
    <examineTemplate
      :property="examineTemplate.workflowData"
    ></examineTemplate>

    <span slot="footer" class="dialog-footer">
      <el-button v-if="view === 'edit'" type="primary" @click="save">保存</el-button>
      <el-button v-if="view === 'examine'" type="primary" @click="agreeClick">同意</el-button>
      <el-button v-if="view === 'examine'" style="margin-left: 3%" type="danger" @click="refuseClick">不同意</el-button>
      <el-button style="margin-left: 3%" type="primary" @click="jksqdClose">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import PublicBuill from './js/publicBuill'
import examineTemplate from './examineTemplate'
import billTitleTemplate from './billTitleTemplate'
export default {
  components: {
    examineTemplate,
    billTitleTemplate
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    property: Object,
    // eslint-disable-next-line vue/require-default-prop
    view: String,
    toVoid: Boolean
  },
  data() {
    return {
      user: {},
      jksqd: {},
      bxnrArr: [],
      workflowData: [],
      show: true,
      /* 编辑页面所需 */
      optionsFyBxUser: [],
      lcPersons: ['', '', '', '', '', '', '', '', '', ''], // 流程人员
      examineTemplate: {
        workflowData: []
      },
      /* 审核需要数据 */
      oaSqdSh: {
        userNo: localStorage.getItem('userNo'),
        isAgree: '',
        shyj: '',
        documentType: '',
        flowId: '',
        maindjh: '',
        lb: '',
        shr: localStorage.getItem('userName'),
        shrNo: localStorage.getItem('userNo'),
        shje: ''
      },
      saveUrl: '',
      jeDx: '',
      jeXx: ''

    }
  },
  mounted() {
    this.initData(this.property)
    if (this.view === 'edit') {
      PublicBuill.getFyBxUser() // 办理人
    }
  },
  created() {
    PublicBuill.setThis(this)
  },
  methods: {
    /* 数据初始化 */
    initData(billDataAll) {
      this.jksqd = billDataAll.BillData
      this.user.companyTitle = billDataAll.company
      /* 审核使用字段 */
      this.oaSqdSh.maindjh = this.jksqd.djh
      this.oaSqdSh.flowId = this.jksqd.flowId
      this.oaSqdSh.shje = this.jksqd.je
      this.oaSqdSh.documentType = 'jksqd0'
      this.oaSqdSh.lb = 'jksqd'

      this.jksqd.lrrId = localStorage.getItem('userNo')

      this.jeDx = PublicBuill.convertCurrency(this.jksqd.je)
      this.jeXx = PublicBuill.formatAmount(this.jksqd.je)

      this.saveUrl = this.jksqd.rejected === '1' ? '/fesback/loadForm/restartWorkflow.z' : '/fesback/loadForm/editJKSQD.z'
      /* 工作流信息 */
      this.examineTemplate.workflowData = []
      if (billDataAll.examineData) {
        const oldShLc = {
          jksqd01: '部门负责人',
          jksqd02: '审核会计',
          jksqd03: '副总经理',
          jksqd04: '财务部长',
          jksqd05: '总经理',
          jksqd06: '总会计师',
          jksqd07: '董事长',
          jksqd08: '集团总裁',
          jksqd09: '集团CFO'
        }

        for (let i = 0; i < billDataAll.examineData.length; i++) {
          const val = billDataAll.examineData[i]
          if (!this.jksqd.flowId) {
            val.lcName = oldShLc[val.lcid]
          }
          const nodeName = val.lcName

          if (nodeName === '经办人') {
            val.auditStatus = '提交'
          } else if (val.shbz === '0') {
            val.auditStatus = '退回'
          } else {
            val.auditStatus = '批准'
          }
          if (nodeName !== '经办人') {
            const receivedPersons = val.shr
            if (nodeName === '集团总裁') {
              this.lcPersons[9] = receivedPersons
            } else if (nodeName === '集团CFO') {
              this.lcPersons[8] = receivedPersons
            } else if (nodeName === '总经理') {
              this.lcPersons[7] = receivedPersons
            } else if (nodeName === '董事长') {
              this.lcPersons[6] = receivedPersons
            } else if (nodeName === '总会计师') {
              this.lcPersons[5] = receivedPersons
            } else if (nodeName === '副总经理') {
              this.lcPersons[4] = receivedPersons
            } else if (nodeName === '财务部长') {
              this.lcPersons[3] = receivedPersons
            } else if (nodeName === '部门负责人') {
              this.lcPersons[2] = receivedPersons
            } else if (nodeName === '审核会计') {
              this.lcPersons[1] = receivedPersons
            }
          }
          if (val.shr)
            this.examineTemplate.workflowData.push(val)
          if (i === 0 && nodeName !== '归档' && this.jksqd.recipient) {
            this.examineTemplate.workflowData.unshift({
              shr: this.jksqd.recipient,
              auditStatus: '未办理'
            })
          }
        }
      }
    },
    /* 金额 */
    jeChange() {
      this.jeDx = PublicBuill.convertCurrency(this.jksqd.je)
    },
    agreeClick() {
      PublicBuill.agreeClick()
    },
    refuseClick() {
      PublicBuill.refuseClick()
    },
    queryBillData() {
      this.jksqdClose()
      this.$emit('queryBillData')
    },
    /* 保存 */
    save() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$post(this.saveUrl, this.jksqd).then(response => {
        if (response.success === true) {
          this.$message.success(response.message)
        } else {
          this.$message.error(response.message)
        }
        loading.close()
        this.jksqdClose()
      })
    },
    jksqdClose() {
      this.show = false
      this.$emit('fksqdClose')
    },
    jkrChange(event) {

      this.jkr = event[0]
      this.jkrid = event[1]
      this.bmbm = event[2]
      this.bmmc = event[3]
    }

  }
}
</script>

<style scoped>
  table,table tr th, table tr td {
    border:1px solid #000000;
  }
</style>
